/* eslint-disable quote-props */
import { toRem } from 'helpers/theme'

const style = ({ theme }) => ({
    marginTop: toRem(-150),

    img: {
        width: '100%'
    },

    [theme.breakpoints.down('md')]: {
        marginTop: toRem(150)
    },

    '.Contact-hero': {
        position: 'absolute',
        top: toRem(80),
        zIndex: -1,
        background: `url("/images/contact-hero.png") no-repeat center top`,
        width: '100%',
        height: '100%',
        backgroundSize: '100%',
        display: 'none',

        '&--mobile': {
            display: 'none',

            [theme.breakpoints.down('md')]: {
                position: 'absolute',
                top: toRem(80),
                zIndex: -1,
                display: 'block',
                background: `url("/images/contact-hero-mobile.png") no-repeat center top`,
                width: '100%',
                height: '100%',
                backgroundSize: '100%'
            }
        },

        [theme.breakpoints.up('md')]: {
            top: toRem(100),
            display: 'block'
        }
    }
})

export default style
